<template>
  <div
    class="cs-switcher"
    :class="{
      [size]: true,
      checked: internalValue,
      disabled: internalDisabled
    }"
    @click="handleClick"
  >
    <div class="cs-switcher-background" />
    <div class="cs-switcher-button" />

    <div v-if="label" class="cs-switcher-label" v-html="label"></div>
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  props: {
    value: Boolean,
    size: {
      type: String,
      validator: inArray(['small', 'normal', 'large']),
      default() {
        return 'normal';
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    label: String,
  },
  data() {
    return {
      internalValue: false,
      internalDisabled: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = val;
      },
    },
    disabled: {
      immediate: true,
      handler(val) {
        this.internalDisabled = val;
      },
    },
  },
  methods: {
    handleClick() {
      if (this.internalDisabled) {
        return;
      }

      this.$emit('input', !this.internalValue);
    },
  },
};
</script>

<style lang="sass" scoped>
  .cs-switcher
    position: relative
    display: inline-flex
    align-items: center
    line-height: 22px
    cursor: pointer

    &.disabled
      opacity: .6
      cursor: default

    &.normal
      .cs-switcher-background
        width: 40px
        height: 20px

    &.checked
      .cs-switcher-background
        background-color: #7CB342

      .cs-switcher-button
        left: 23px

      .cs-switcher-label
        opacity: 1

  .cs-switcher-background
    flex: none
    border-radius: 50px
    border: 1px solid #fff
    background-color: #232435

  .cs-switcher-button
    position: absolute
    top: 50%
    left: 3px
    width: 14px
    height: 14px
    border-radius: 50%
    background: #ffffff
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25)
    transform: translateY(-50%)
    transition: left .2s ease-out

  .cs-switcher-label
    font-weight: 400
    font-size: 14px
    line-height: 18px
    margin-left: 20px
    opacity: .5
</style>
